import { Reducer } from "redux";
import { IAuth as Auth, IUser } from "../../models/auth";
import { Action, ActionType } from "../actionTypes/authActionTypes";

export interface IAuthState {
  authStatus: boolean;
  user: IUser;
  loading: boolean;
  error?: string | null;
  errorMessage?: string | null;
  rememberedUsername: string;
  rememberedPassword: string;
}

const initialState = {
  authStatus: false,
  user: {} as IUser,
  loading: false,
  error: null,
  errorMessage: null,
  rememberedUsername: "",
  rememberedPassword: "",
};

export const AuthReducer: Reducer<IAuthState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.AUTH_START:
      return { ...state, loading: true };
    case ActionType.AUTH_SUCCESS:
      const auth: Auth = action.payload;
      return {
        ...state,
        authStatus: auth.authStatus,
        user: auth.user,
        error: null,
        loading: false,
      };
    case ActionType.AUTH_FAIL:
      return {
        ...state,
        error: action.payload?.code,
        errorMessage: action.payload?.message,
        loading: false,
      };
    case ActionType.DO_LOGOUT:
      return {
        ...initialState,
        rememberedUsername: state.rememberedUsername,
        rememberedPassword: state.rememberedPassword,
      };
    case ActionType.RESET_REDUX_STATE: {
      return {
        ...initialState,
        rememberedUsername: state.rememberedUsername,
        rememberedPassword: state.rememberedPassword,
      };
    }
    case ActionType.REMEMBER_PASSWORD:
      return {
        ...state,
        rememberedUsername: action.payload.username,
        rememberedPassword: action.payload.password,
      };
    default:
      return state;
  }
};
